module.exports = __webpack_public_path__ + "img/Ellipse3.10f88626.png";